<ng-template #configModal let-modal>
  <form #f="ngForm" (ngSubmit)="modal.close(updateEntry)">
    <div class="modal-header justify-content-center">
      <button type="button" class="close" (click)="modal.dismiss('cancel')">
        <fa-icon [icon]="['fal','times']"></fa-icon>
      </button>
      <h4 *ngIf="updateEntry.input === 'number'" class="title">Number Configuration</h4>
      <h4 *ngIf="updateEntry.input === 'scale'" class="title">Choices Configuration</h4>
    </div>
    <div class="modal-body" *ngIf="updateEntry.input === 'number'">
      <div>
        <label>Minimum Value:</label>
        <div style="max-width: 30em">
          <input
            class="form-control"
            name="input-min-value"
            type="number"
            [(ngModel)]="updateEntry.config.min"
            [ngModelOptions]="{updateOn: 'submit'}"
          />
        </div>
      </div>
      <div>
        <label>Maximum Value:</label>
        <div style="max-width: 30em">
          <input
            class="form-control"
            name="input-max-value"
            type="number"
            [(ngModel)]="updateEntry.config.max"
            [ngModelOptions]="{updateOn: 'submit'}"
          />
        </div>
      </div>
      <div>
        <label>Decimal Digits:</label>
        <div style="max-width: 30em">
          <input
            required
            class="form-control"
            name="input-decimal"
            type="number"
            [(ngModel)]="updateEntry.config.decimal"
            [ngModelOptions]="{updateOn: 'submit'}"
            min="0"
            max="3"
          />
        </div>
      </div>
    </div>
    <div class="modal-body" *ngIf="updateEntry.input === 'scale'">
      <div class="my-5">
        <label>Choices:</label>
        <div>
          <div *ngFor="let o of updateOptions; let n = index">
            <div style="display: flex; margin: 2px">
              <div style="float: left; flex-grow: 1">
                <input
                  class="form-control"
                  type="text"
                  [(ngModel)]="updateOptions[n]"
                  [name]="'input-option-' + n"
                  [ngModelOptions]="{updateOn: 'submit'}"
                />
              </div>
              <div style="float: right">
                <button type="button" class="btn btn-danger btn-sm btn-spaced" (click)="deleteConfigOption(n)">
                  <fa-icon [icon]="['fal','trash']"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-success btn-sm btn-spaced" (click)="addConfigOption()">
          <fa-icon [icon]="['fal','plus']"></fa-icon>
          Add Choice
        </button>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-sm btn-spaced" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-primary btn-sm btn-spaced">Update</button>
    </div>
  </form>
</ng-template>

<div class="container-fluid" style="font-size: 15px">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h2>Survey</h2>
        </div>
        <div class="card-body" *ngIf="!exists && !loading">
          <h4>Not found</h4>
        </div>
        <div class="card-body" *ngIf="exists && !loading">
          <div>
            <label> Title: </label>
            <div style="max-width: 30em">
              <app-input-selector type="text" [value]="survey?.title" (update)="updateTitle($event)"></app-input-selector>
            </div>
            <label> Subtitle: </label>
            <div style="max-width: 30em">
              <app-input-selector type="text" [value]="survey?.setup?.subtitle" (update)="updateSubtitle($event)"></app-input-selector>
            </div>
            <label> Start: </label>
            <div style="max-width: 30em">
              <app-input-selector
                type="date"
                [value]="survey?.start"
                (update)="updateStartDate($event)"
                deletable="true"
              ></app-input-selector>
            </div>
            <label> End: </label>
            <div style="max-width: 30em">
              <app-input-selector type="date" [value]="survey?.end" (update)="updateEndDate($event)" deletable="true"></app-input-selector>
            </div>
          </div>
          <div>
            <table *ngIf="entries?.length > 0" class="table">
              <thead>
                <tr>
                  <th class="text-left" style="min-width: 40%">Text</th>
                  <th class="text-left" style="max-width: 20%">Type</th>
                  <th class="text-left" style="max-width: 20%">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let e of entries; let i = index">
                  <td class="text-left">
                    <app-input-selector type="text" [value]="e.text" (update)="hasChanged = true"></app-input-selector>
                  </td>
                  <td class="text-left">
                    <select
                      class="form-control select-small"
                      style="width: auto"
                      id="type"
                      (change)="setSelectedType(e, $event.target.value)"
                    >
                      <option *ngFor="let t of types" [selected]="getSelectedType(e) == t">{{ t.display }}</option>
                    </select>
                  </td>
                  <td class="text-left">
                    <button class="btn btn-info btn-sm btn-spaced" (click)="editConfig(e, configModal)" [disabled]="!canEditConfig(e)">
                      <fa-icon [icon]="['fal','cog']"></fa-icon>
                    </button>
                    <button class="btn btn-primary btn-sm btn-spaced" (click)="move(i, -1)" [disabled]="i==0">
                      <fa-icon [icon]="['fal','arrow-up']"></fa-icon>
                    </button>
                    <button
                      class="btn btn-primary btn-sm btn-spaced"
                      (click)="move(i, +1)"
                      [disabled]="i+1==survey?.setup?.entries?.length"
                    >
                      <fa-icon [icon]="['fal','arrow-down']"></fa-icon>
                    </button>
                    <button class="btn btn-danger btn-sm btn-spaced" (click)="delete(i)">
                      <fa-icon [icon]="['fal','trash']"></fa-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="btn btn-success btn-sm btn-spaced" (click)="addEntry()">
              <fa-icon [icon]="['fal','plus']"></fa-icon>
              Add Survey Question
            </button>
          </div>
          <div class="text-center">
            <button *ngIf="createNew" class="btn btn-success btn-sm btn-spaced" (click)="save()" [disabled]="!hasChanged">Create</button>
            <button *ngIf="!createNew" class="btn btn-primary btn-sm btn-spaced" (click)="save()" [disabled]="!hasChanged">Save</button>
            <button class="btn btn-danger btn-sm btn-spaced" (click)="cancel()">{{ hasChanged ? 'Cancel' : 'Back' }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
